<template>
    <Dragons :dragons=dragons :elements=elements :is-top=true ></Dragons>
</template>

<script>
import Dragons from './Dragons.vue'

export default {
    name: 'Top',
    components: {
        Dragons
    },
    props: {
        dragons: Array,
        elements: Array,
    },
}
</script>
